import { ReportContentNS } from 'components/report-content/index';
import LineChart from 'components/report-content/components/line-chart/LineChart';
import LineChartEditPanel from 'components/report-content/components/line-chart/LineChartEditPanel';
import React from 'react';
import ComponentSettingsLineChart = ReportContentNS.ComponentSettingsLineChart;

export default class LineChartComponentBuilder extends ReportContentNS.AbstractComponentBuilder<ComponentSettingsLineChart> {
    getComponent() {
        return (
            <LineChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <LineChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
